<template>
	<DrawerPanel
		ref="termsdrawer"
		title="Terms & Conditions"
		bottom="-32px"
		openHeight="95%"
		closedHeight="0px"
		:startOpened="false"
		:back="true"
		:close="true"
		:divider="true"
		backgroundColor="#FFFFFF"
		openBackgroundColor="#FFFFFF"
		@goBack="closeDrawer"
	>
		<div class="terms-container">
			<iframe 
				:src="termsUrl" 
				class="terms-iframe"
				frameborder="0"
			></iframe>
		</div>
	</DrawerPanel>
</template>

<script>
import DrawerPanel from './DrawerPanel.vue';

export default {
	name: 'QuizDrawerTermsPanel',
	components: {
		DrawerPanel
	},
	props: {
		termsUrl: {
			type: String,
			default: 'https://s3.eu-west-2.amazonaws.com/content.sysodev.link/5713bc01-QuizTerms.pdf#view=FitH'
		}
	},
	data() {
		return {
			wasHidden: false
		}
	},
	mounted() {
		// Listen for page visibility changes (when user leaves/returns to app)
		document.addEventListener('visibilitychange', this.handleVisibilityChange);
	},
	beforeUnmount() {
		document.removeEventListener('visibilitychange', this.handleVisibilityChange);
	},
	methods: {
		openDrawer() {
			this.$refs.termsdrawer.openDrawer();
			this.wasHidden = false;
		},
		closeDrawer() {
			this.$refs.termsdrawer.closeDrawer();
		},
		handleVisibilityChange() {
			// When user leaves the app (e.g., to view PDF in external browser)
			if (document.hidden) {
				this.wasHidden = true;
			} 
			// When user returns to the app after viewing PDF
			else if (this.wasHidden) {
				this.wasHidden = false;
				// Close the drawer since iframe content will be empty
				this.closeDrawer();
			}
		}
	}
}
</script>

<style scoped>
.terms-container {
	width: 100%;
	height: 100%;
	display: flex;
	flex-direction: column;
	margin: 0;
	padding: 0;
}

.terms-iframe {
	width: 100%;
	flex: 1;
	border: none;
	background: #FFFFFF;
}
</style>
